import { useHorizontalSign } from "../../hooks/queries/horizontalSigning/useHorizontalSigns"

import * as Styled from "./HorizontalSignDocumentList.styled"

export const HorizontalSignDocumentList = (props) => {
    const { signId } = props

    const { data } = useHorizontalSign(signId)

    return <Styled.List documents={data?.documents} subNetworks={data?.sub_networks} />
}